import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Camara from '../../../components/contas/camara'


function ContasScreen() {
    return (
        <Fragment>
            <Head titulo="Resultado da Apreciação do Poder Legislativo" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/contas'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Camara />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ContasScreen;